import { z } from 'zod';
import { EMAIL_PATTERN } from './policies/email.js';
import { PHONE_PATTERN } from './policies/phone.js';
/**
 * Input schema for `PATCH /organizations/:slug/settings/guest-facing`.
 *
 * All 4 fields are nullable — callers may clear any field individually.
 * Email and phone fields are validated against shared policy patterns
 * (EMAIL_PATTERN / PHONE_PATTERN) when non-null.
 * Free-text fields (name, address) accept any string including
 * injection-shaped values — sanitisation happens downstream in the
 * domain VO.
 *
 * `.strict()` rejects extra keys so that callers cannot smuggle
 * additional fields past the validation boundary.
 */
export const updateGuestFacingInfoSchema = z
    .object({
    name: z.string().nullable(),
    address: z.string().nullable(),
    email: z.string().regex(EMAIL_PATTERN).nullable(),
    phone: z.string().regex(PHONE_PATTERN).nullable(),
})
    .strict();
//# sourceMappingURL=guest-facing-info.schema.js.map